import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { formatDate, parseDate } from 'react-day-picker/moment'
import numeral from 'numeral'
import MultiSelect from '@khanacademy/react-multi-select'

import PaymentAgreementBlocker from 'Pods/NewModelUploader/Components/BottomBar/Components/PaymentAgreementBlocker'
import InputField from 'Pods/Shared/InputField'
import { run, RuleRunner } from 'Pods/Shared/RuleRunner'
import * as ValidationRules from 'Pods/Shared/Rules/Rules'
import InputCheckbox from 'Pods/Shared/InputCheckbox'
import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'
import InputFieldWithPrefix from 'Pods/Shared/InputFieldWithPrefix'
import UserSearch from 'Pods/Shared/UserSearch/UserSearch'
import FileUpload from 'Pods/Shared/FileUpload'
import RichEditor from 'Pods/Shared/RichEditor/RichEditor'
import PickerClasses from 'Pods/Shared/DatePickClassNames'

import paymentAgreementBlockerFromError from 'Utils/paymentAgreementBlockerFromError'

import CommissionNotice from '../../Shared/CommissionNotice'
import CancelJobModal from '../../../Profile/JobsDashboard/Modals/CancelJobModal'
import SuggestJobModal from '../../../Profile/JobsDashboard/Modals/SuggestJobModal'

import TopInfoBar from './TopInfoBar'
import CurrentUser from './CurrentUser'

class CreateProjectForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = this.getInitialState(props)

    this.handleInputChange = this.handleInputChange.bind(this)
    this.toggleChecked = this.toggleChecked.bind(this)
    this.toggleType = this.toggleType.bind(this)
    this.updateUsersList = this.updateUsersList.bind(this)
    this.removeUser = this.removeUser.bind(this)
    this.clearAllUsers = this.clearAllUsers.bind(this)
    this.onSelectChange = this.onSelectChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.getJobAttachments = this.getJobAttachments.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
    this.onUserFetchSuccess = this.onUserFetchSuccess.bind(this)
    this.fillInForm = this.fillInForm.bind(this)
    this.softwareFetchSuccess = this.softwareFetchSuccess.bind(this)
    this.skillsFetchSuccess = this.skillsFetchSuccess.bind(this)
    this.acceptAndPay = this.acceptAndPay.bind(this)
    this.onAcceptOfferSuccess = this.onAcceptOfferSuccess.bind(this)
    this.isInviteFieldInvalid = this.isInviteFieldInvalid.bind(this)
    this.onDayChange = this.onDayChange.bind(this)
    this.handleEditorChange = this.handleEditorChange.bind(this)
    this.continuePost = this.continuePost.bind(this)
    this.editProject = this.editProject.bind(this)
    this.getSubmitParams = this.getSubmitParams.bind(this)
    this.getProjectTypeByScope = this.getProjectTypeByScope.bind(this)
    this.closePaymentAgreementBlocker = this.closePaymentAgreementBlocker.bind(this)
  }

  getInitialState(props) {
    return {
      data: {
        type: props.scope === 'hire-designer' ? (props.username ? 'initiated_by_buyer' : 'public') : 'initiated_by_designer',
        title: '',
        users: [],
        emails: [],
        description: '',
        software: [],
        skills: [],
        files: [],
        deadline: '',
        budget: '',
        resell: false,
        terms: false,
        jobAttachments: [],
        isEndless: false,
      },
      availableSoftware: [],
      availableSkills: [],
      showErrors: false,
      validationErrors: {},
      fetchedUser: {},
      disableSubmit: false,
      cancelModalIsOpen: false,
      isEdited: false,
      isViewerDesigner: false,
      showModal: false,
      inviteUrl: '',
      redirectId: 0,
      wasEditShown: false,
      paymentAgreementBlocker: null,
      modalParams: {
        primaryAction: () => { this.editProject() },
        secondaryAction: () => { this.continuePost() },
      },
    }
  }

  componentDidMount() {
    this.fetchSkills()
    this.fetchSoftware()

    if (this.props.username) this.fetchUserInfo(this.props.username)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.scope !== this.props.scope) {
      this.setState(prevState => ({
        data: {
          ...prevState.data,
          type: this.props.scope === 'hire-designer' ? 'public' : 'initiated_by_designer',
        },
      }))
    }
  }

  fetchSoftware() {
    axios.get('/api/internal/jobs/software')
      .then(this.softwareFetchSuccess)
      .catch(error => App.events.publish('app:notification:flash:error', error.response.data.error))
  }

  softwareFetchSuccess(response) {
    this.setState({
      availableSoftware: response.data,
    }, this.fetchProjectData)
  }

  fetchSkills() {
    axios.get('/api/internal/jobs/skills')
      .then(this.skillsFetchSuccess)
      .catch(error => App.events.publish('app:notification:flash:error', error.response.data.error))
  }

  skillsFetchSuccess(response) {
    this.setState({ availableSkills: response.data })
  }

  fetchProjectData() {
    if (this.props.id && ['edit', 'review', 'repost'].includes(this.props.scope)) {
      axios.get(`/api/internal/jobs/${this.props.id}`)
        .then(this.fillInForm)
        .catch((error) => { })
    }
  }

  fetchUserInfo(username) {
    axios.get(`/api/internal/users/${username}`)
      .then(this.onUserFetchSuccess)
      .catch((error) => { })
  }

  onUserFetchSuccess(response) {
    this.setState(prevState => ({
      fetchedUser: response.data.data.attributes,
      data: {
        ...prevState.data,
        users: [response.data.data.id],
      },
    }))
  }

  fieldValidations(type) {
    const minBudget = type === 'public' ? 5 : 2
    const errors = [
      RuleRunner('title', 'Title', ValidationRules.required, ValidationRules.onlyLatinSymbols, ValidationRules.isLimitedLength),
      RuleRunner('description', 'Description', ValidationRules.required, ValidationRules.noEmoji),
      RuleRunner('budget', 'Budget', ValidationRules.min(minBudget), ValidationRules.max(1000000), ValidationRules.required),
      RuleRunner('software', '3D Software', ValidationRules.required),
    ]

    if (!this.state.data.isEndless) {
      errors.push(RuleRunner('deadline', 'Deadline', ValidationRules.required))
    }

    return (errors)
  }

  // Functional updater: React 18 batches setState, so this.state may be stale (see handleEditorChange).
  handleInputChange(e) {
    const { name, value } = e.target

    this.setState(prevState => {
      const newState = update(prevState, { data: { [name]: { $set: value } } })

      newState.validationErrors = run(newState.data, this.fieldValidations(prevState.data.type))
      newState.isEdited = true

      return newState
    })
  }

  // Functional updater: React 18 batches setState, so this.state may be stale (see handleEditorChange).
  toggleChecked(target) {
    this.setState(prevState => {
      const updates = { [target]: { $set: !prevState.data[target] } }

      if (target === 'isEndless') {
        updates.deadline = { $set: '' }
      }

      const newState = update(prevState, { data: updates })

      newState.isEdited = target !== 'terms'

      return newState
    })
  }

  // Functional updater: React 18 batches setState, so this.state may be stale (see handleEditorChange).
  toggleType(event) {
    const newType = this.props.scope === 'hire-designer' ? (event.target.checked ? 'initiated_by_buyer' : 'public') : 'initiated_by_designer'

    this.setState(prevState => {
      const newState = update(prevState, { data: { type: { $set: newType } } })

      newState.validationErrors = run(newState.data, this.fieldValidations(newType))

      return newState
    })
  }

  updateUsersList(usersList, type) {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [type]: [...prevState.data[type], usersList],
      },
    }))
  }

  removeUser(user, type) {
    this.setState(prevState => {
      const list = prevState.data[type]

      return {
        data: {
          ...prevState.data,
          [type]: list.filter(currUser => currUser !== user),
        },
      }
    })
  }

  clearAllUsers() {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        users: [],
        emails: [],
      },
    }))
  }

  // Functional updater: React 18 batches setState, so this.state may be stale (see handleEditorChange).
  onSelectChange(type, value) {
    this.setState(prevState => {
      const newState = update(prevState, { data: { [type]: { $set: value } } })

      newState.validationErrors = run(newState.data, this.fieldValidations(prevState.data.type))
      newState.isEdited = true

      return newState
    })
  }

  // Functional updater: React 18 batches setState, so this.state may be stale (see handleEditorChange).
  onDayChange(value = '') {
    this.setState(prevState => {
      const newState = update(prevState, {
        data: {
          deadline: { $set: value },
          isEndless: { $set: false },
        },
      })

      newState.validationErrors = run(newState.data, this.fieldValidations(prevState.data.type))
      newState.isEdited = true

      return newState
    })
  }

  getJobAttachments(list) {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        jobAttachments: list,
      },
    }))
  }

  getJobAttachments(list) {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        jobAttachments: list,
      },
    }))
  }

  resellLabel() {
    const allowResell = 'I allow the designer to sell Project results on the marketplace'
    const requestResell = 'Request permission to sell Project results on the markerplace'

    switch (this.props.scope) {
      case 'hire-designer':
        return allowResell

      case 'invite-client':
        return requestResell

      default:
        return this.state.isViewerDesigner ? requestResell : allowResell
    }
  }

  errorFor(field) {
    return this.state.validationErrors[field] || ''
  }

  isFormGroupValid(field) {
    return this.state.showErrors && this.state.validationErrors[field] ? ' is-invalid' : ''
  }

  showModal(modalState) {
    this.setState({ [modalState]: true })
  }

  closeModal(modalState) {
    this.setState({ [modalState]: false })
  }

  onAcceptOfferSuccess(url) {
    App.events.publish('app:notification:flash:success', 'You have accepted the offer')
    url ? window.location.href = url : window.location.reload()
  }

  acceptAndPay() {
    const dataParams = { data: { attributes: { application_id: this.state.data.applicationId } } }

    axios.put(`/api/internal/jobs/${this.props.id}/accept_and_pay`, dataParams)
      .then(response => this.onAcceptOfferSuccess(response.data.data.attributes.url))
      .catch(this.onSubmitFailure)
  }

  fillInForm(response) {
    const data = response.data.data.attributes
    const fetchUser = () => {
      return this.props.scope === 'review' ? this.fetchUserInfo(response.data.data.attributes.designerUsername) : false
    }

    const softwareList = this.state.availableSoftware.filter(item => data.software.includes(item.text))
    const skillsList = this.state.availableSkills.filter(item => data.skills.includes(item.label))

    this.setState({
      data: {
        type: data.type,
        title: data.title,
        users: [],
        emails: [],
        description: data.plainDescription,
        skills: skillsList.map(item => item.value),
        software: softwareList.map(item => item.id),
        files: response.data.included,
        fileUploadUrl: data.attachmentUploadUrl,
        deadline: this.props.scope === 'repost' ? '' : data.deadlinePlain,
        budget: data.budget,
        resell: data.isResellable,
        terms: true,
        jobAttachments: [],
        applicationId: data.applicationId,
        isEndless: data.endless,
      },
      isViewerDesigner: data.isViewerDesigner,
    }, fetchUser)
  }

  getSubmitParams() {
    const { data } = this.state

    return {
      data: {
        attributes: {
          type: data.type,
          title: data.title,
          description: data.description,
          budget: data.budget,
          deadline: data.isEndless ? '' : data.deadline,
          agreed_to_terms_of_use: data.terms,
          release_ip_rights: data.resell,
          file_types: data.software,
          skills: data.skills,
          job_attachments: data.jobAttachments,
          users: data.users,
          emails: data.emails,
          designer: (this.props.username ? data.users[0] : null),
          meta_source: this.props.metaSource,
          endless: data.isEndless,
        },
      },
    }
  }

  getProjectTypeByScope(scope) {
    switch (scope) {
      case 'hire-designer':
        return 'Hire 3D Designer'
      case 'invite-client':
        return 'Invite a client'
      default:
        return ''
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    const { wasEditShown, data } = this.state
    const { description, jobAttachments } = data
    const newState = this.state
    const params = this.getSubmitParams()
    const couldDescriptionBeImproved = description.length < 50
    const couldPreviewBeImproved = jobAttachments.length === 0

    newState.validationErrors = run(data, this.fieldValidations(this.state.data.type))
    newState.showErrors = true

    this.setState(newState)

    if (Object.getOwnPropertyNames(newState.validationErrors).length === 0 && !this.isInviteFieldInvalid()) {
      this.setState({ disableSubmit: true })

      if (this.props.scope === 'edit' || this.props.scope === 'review') {
        axios.put(`/api/internal/jobs/${this.props.id}`, params)
          .then(response => this.onSubmitSuccess(response, null)).catch(this.onSubmitFailure)
      } else if (this.props.scope === 'repost') {
        axios.post(`/api/internal/jobs/${this.props.id}/repost`, params)
          .then(response => this.onSubmitSuccess(response, 'Repost a project')).catch(this.onSubmitFailure)
      } else if (this.state.data.type === 'public' && !wasEditShown
        && (couldDescriptionBeImproved || couldPreviewBeImproved)) {
        this.showEditModal(couldDescriptionBeImproved, couldPreviewBeImproved)
      } else {
        axios.post('/api/internal/jobs', params)
          .then(response => this.onSubmitSuccess(response, 'Post a project')).catch(this.onSubmitFailure)
      }
    }
  }

  continuePost() {
    const params = this.getSubmitParams()

    this.setState({
      wasEditShown: true,
      shouldEditBeShown: false,
    }, () => {
      axios.post('/api/internal/jobs', params)
        .then(response => this.onSubmitSuccess(response, 'Post a project')).catch(this.onSubmitFailure)
    })
  }

  editProject() {
    this.setState({
      wasEditShown: true,
      shouldEditBeShown: false,
      disableSubmit: false,
    })
  }

  showEditModal(couldDescriptionBeImproved, couldPreviewBeImproved) {
    const { modalParams } = this.state

    this.setState({
      modalParams: {
        couldDescriptionBeImproved,
        couldPreviewBeImproved,
        ...modalParams,
      },
      shouldEditBeShown: couldDescriptionBeImproved || couldPreviewBeImproved,
    })
  }

  trackProjectPost(id) {
    const params = this.getSubmitParams()
    const {
      data: {
        attributes: {
          budget,
          file_types: fileTypes,
        },
      },
    } = params

    const { scope } = this.props

    const { availableSoftware } = this.state

    const selectedSoftware = fileTypes
    const matchingLabels = availableSoftware
      .filter(item => selectedSoftware.includes(item.id)).map(item => item.text)

    window.customEventTracker({
      name: 'start_a_project',
      userId: App.config.userId || '',
      eventData: {
        project_id: `${id}`,
        project_budget: parseFloat(budget).toFixed(2),
        offer_type: this.getProjectTypeByScope(scope),
        '3d_software': matchingLabels.join('_'),
      },
    })
  }

  onSubmitSuccess(response, gtmEvent) {
    const {
      data: {
        message,
        data: {
          attributes: {
            id,
            inviteUrl,
            additional_info: additionalInfo,
          },
        },
      },
    } = response

    const { job_id: jobId } = additionalInfo || {}
    const { data: { type } } = this.state

    const { username, scope } = this.props

    App.events.publish('app:notification:flash:success', message || 'Update successful')

    if (gtmEvent === 'Post a project') {
      this.trackProjectPost(id || jobId)
    }

    const newState = {
      redirectId: id,
      inviteUrl,
    }

    if (username || type === 'initiated_by_designer' || scope === 'edit') {
      this.setState(newState, this.redirect(id))
    } else {
      this.setState(newState, this.redirect(id, true))
    }
  }

  onSubmitFailure(xhr) {
    this.setState({ disableSubmit: false })

    const blocker = paymentAgreementBlockerFromError(xhr)

    if (blocker) {
      this.setState({ paymentAgreementBlocker: blocker })
      return
    }

    if (xhr.response.data && xhr.response.data.errors) {
      App.events.publish('app:notification:flash:error', xhr.response.data.errors[0])
    } else {
      App.events.publish('app:notification:flash:error', 'Something went wrong, please try again')
    }
  }

  closePaymentAgreementBlocker() {
    this.setState({ paymentAgreementBlocker: null })
  }

  redirect(id = this.state.redirectId, successScreen = false) {
    id ? (
      successScreen ? (
        window.location.href = `/3d-modeling-jobs/${id}/success`
      ) : (
        window.location.href = `/profile/projects/${id}`
      )
    ) : (
      window.location.href = '/profile/projects'
    )
  }

  isInviteFieldInvalid() {
    return this.props.scope === 'invite-client'
      && this.state.data.emails.length === 0 && this.state.data.users.length === 0
  }

  // React 18 batches all setState calls, including inside promises. Using a functional
  // updater ensures prevState reflects prior setState calls (e.g. fillInForm) that
  // haven't been flushed yet, avoiding stale reads from this.state.
  handleEditorChange(value) {
    this.setState(prevState => {
      const newState = update(prevState, { data: { description: { $set: value } } })

      newState.validationErrors = run(newState.data, this.fieldValidations(prevState.data.type))
      newState.isEdited = true

      return newState
    })
  }

  render() {
    const earningsRatio = 0.95

    const resellTooltip = this.props.scope === 'hire-designer' ? 'By checking this checkbox you agree that you '
      + 'renounce exclusive rights to content created with this 3D Project and allow designer to retain the Intellectual '
      + 'property rights and publish Project results on the CGTrader marketplace.' : null

    const earningsTooltip = 'Your approximate revenue is counted after calculating approximate payment processing '
      + 'fees and 5% earnings received by CGTrader. Please note that your final revenue may vary a little bit due to '
      + 'payment processing fee calculation.'

    const { wasEditShown, shouldEditBeShown, modalParams } = this.state

    return (
      <Fragment>
        {this.props.scope === 'invite-client' && <TopInfoBar />}

        <form className={`${this.props.isModal ? '' : 'card '}create-project-form`} onSubmit={this.handleSubmit} autoComplete="off">
          <InputField
            label="Title"
            id="project-title"
            name="title"
            type="text"
            placeholder="Type here…"
            errorText={this.errorFor('title')}
            showError={this.state.showErrors}
            value={this.state.data.title}
            formClassName="form-group-grey"
            inputClassName="form-control-grey"
            onChange={this.handleInputChange}
            required
          />

          {(this.props.username || this.props.scope === 'review') ? (
            <CurrentUser
              user={this.state.fetchedUser}
              label={this.props.scope === 'invite-client' ? 'Selected client' : 'Selected designer'}
            />
          ) : (
            (this.props.scope !== 'edit' && this.props.scope !== 'repost') && (
              <Fragment>
                {this.state.data.type !== 'initiated_by_designer' && (
                  <div className="scope-switcher">
                    <span className={this.state.data.type === 'public' ? 'is-active' : ''}>List Project publicly</span>

                    <label className="switch-input switch-input--dual">
                      <input className="switch-input__trigger" type="checkbox" onChange={this.toggleType} />
                      <span className="switch-input__slider" />
                    </label>

                    <span className={this.state.data.type === 'private' ? 'is-active' : ''}>Invite selected designers</span>
                  </div>
                )}

                <div className={`create-project__user-search ${this.state.data.type !== 'public' ? 'is-shown' : ''}`}>
                  <UserSearch
                    id="user-search"
                    type={this.state.data.type}
                    scope={this.props.scope === 'hire-designer' ? 'sellers' : 'buyers'}
                    label={this.props.scope === 'hire-designer' ? 'Select designers' : 'Invite clients'}
                    placeholder={this.props.scope === 'hire-designer' ? 'Type designer\'s username or email here…' : 'Enter the client\'s email or CGTrader Username'}
                    updateUsersList={this.updateUsersList}
                    removeUser={this.removeUser}
                    clearAllUsers={this.clearAllUsers}
                    showError={this.isInviteFieldInvalid() && this.state.showErrors}
                  />
                </div>
              </Fragment>
            )
          )}

          <RichEditor
            label="Description"
            required
            value={this.state.data.description}
            onChange={this.handleEditorChange}
            showError={this.state.showErrors}
            errorText={this.errorFor('description')}
          />

          <div className="form-group form-group-grey">
            <label>3D Skills </label>

            <MultiSelect
              options={this.state.availableSkills}
              onSelectedChanged={id => this.onSelectChange('skills', id)}
              selected={this.state.data.skills}
              placeholder="Select 3D Skills"
              hasSelectAll={false}
              disableSearch
            />
          </div>

          <div className={`form-group form-group-grey create-project__software${this.isFormGroupValid('software')}`}>
            <label>3D Software <b>*</b></label>

            <MultiSelect
              options={this.state.availableSoftware.map(value => ({ value: value.id, label: value.text }))}
              onSelectedChanged={id => this.onSelectChange('software', id)}
              selected={this.state.data.software}
              placeholder="Select 3D Software"
              hasSelectAll={false}
            />
            {this.state.showErrors && this.errorFor('software') && (
              <div className="error-message">
                <span className="text">{this.errorFor('software')}</span>
              </div>
            )}
          </div>

          <div className="form-group-grey">
            <label>Preview Images</label>

            <FileUpload
              uploadUrl="/job_attachments"
              getAttachments={this.getJobAttachments}
              attachments={this.state.data.files}
              ctaText="Drag & drop reference images here or"
            />
          </div>

          <div className={`row form-group form-group-grey create-project__deadline${this.state.data.isEndless ? '' : this.isFormGroupValid('deadline')}`}>
            <div className="col-12 col-md-6">
              <label>Deadline <b>*</b></label>

              <div className="form-group--with-prefix">
                <div className="form-group-prepend">
                  <span className={`form-group-text ${this.state.showErrors}`}>
                    <Icon type={['far', 'calendar']} notSpaced />
                  </span>
                </div>

                <DayPickerInput
                  classNames={PickerClasses.PickerInput}
                  dayPickerProps={{
                    classNames: PickerClasses.DatePickerClasses,
                    disabledDays: { before: new Date() },
                  }}
                  format="YYYY-MM-DD"
                  placeholder="YYYY-MM-DD"
                  parseDate={parseDate}
                  formatDate={formatDate}
                  inputProps={{ name: 'deadline' }}
                  onDayChange={this.onDayChange}
                  value={this.state.data.deadline}
                />
                <span className="day-picker__infinite-checkbox">
                  <InputCheckbox
                    id="isEndless"
                    label="No fixed deadline"
                    checked={this.state.data.isEndless}
                    onChange={this.toggleChecked}
                  />
                </span>
              </div>
              {this.state.showErrors && this.errorFor('deadline') && !this.state.data.isEndless && (
                <div className="error-message">
                  <span className="text">{this.errorFor('deadline')}</span>
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-6 col-md-4 col-lg-3">
              <InputFieldWithPrefix
                label="Budget"
                id="budget"
                name="budget"
                type="number"
                prefix="$"
                required
                simpleError
                placeholder={50}
                errorText={this.errorFor('budget')}
                showError={this.state.showErrors}
                value={this.state.data.budget}
                formClassName="form-group-grey"
                inputClassName="form-control-grey create-project__budget-input"
                onChange={this.handleInputChange}
              />
            </div>
            {this.props.scope === 'invite-client' && this.state.data.budget && (
              <div className="col-6 col-md-4 col-lg-3">
                <div className="form-group form-group-grey">
                  <label>
                    Your earnings
                    <Tooltip id="label-info-earnings" content={earningsTooltip} className="checkbox__info">
                      <Icon type={['fas', 'question-circle']} />
                    </Tooltip>
                  </label>
                  <div className="create-project__earnings">{numeral(this.state.data.budget * earningsRatio).format('$0.[00]')}</div>
                </div>
              </div>
            )}
          </div>

          <div className="cgt-mt-10 cgt-mb-20">
            <CommissionNotice audience="buyer" />
          </div>

          <div className="form-group">
            <InputCheckbox
              id="resell"
              label={this.resellLabel()}
              labelInfo={resellTooltip}
              checked={this.state.data.resell}
              onChange={this.toggleChecked}
            />
            {this.props.scope !== 'edit' && (
              <Fragment>
                <br />
                <InputCheckbox
                  id="terms"
                  label="I agree with the <a href='/pages/terms-and-conditions' target='_blank'>Terms and Conditions</a>"
                  checked={this.state.data.terms}
                  onChange={this.toggleChecked}
                  required
                />
              </Fragment>
            )}
          </div>

          {this.props.scope !== 'edit' && (
            <div className="form-group">
              <label><b>*</b> <small>required</small></label>
            </div>
          )}

          {this.props.scope === 'review' && (
            <CancelJobModal modalIsOpen={this.state.cancelModalIsOpen} id={this.props.id} closeModal={() => this.closeModal('cancelModalIsOpen')} />
          )}

          <div className="u-text-right">
            <div className="publishing-actions__buttons">
              {this.state.paymentAgreementBlocker && (
                <PaymentAgreementBlocker
                  paymentAgreementBlocker={this.state.paymentAgreementBlocker}
                  onClose={this.closePaymentAgreementBlocker}
                />
              )}
              {this.props.scope === 'review' ? (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-outline-default"
                    onClick={() => this.showModal('cancelModalIsOpen')}
                  >
                    Cancel Project
                  </button>

                  {this.state.isEdited ? (
                    <button
                      type="submit"
                      className={`btn btn-primary u-ml10${!this.state.data.terms || this.state.disableSubmit ? ' disabled' : ''}`}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      type="button"
                      className={`btn btn-primary u-ml10${!this.state.data.terms || this.state.disableSubmit ? ' disabled' : ''}`}
                      onClick={this.acceptAndPay}
                    >
                      Accept & Pay
                    </button>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  <button type="button" className="btn btn-outline-default">Cancel</button>

                  <button type="submit" className={`btn btn-primary u-ml10${!this.state.data.terms || this.state.disableSubmit ? ' disabled' : ''}`}>
                    {this.props.scope === 'edit' ? 'Edit Project' : 'Start a Project'}
                  </button>
                </Fragment>
              )}
            </div>
          </div>
        </form>

        {!wasEditShown && shouldEditBeShown && this.state.data.type === 'public' && (
          <SuggestJobModal {...modalParams} />
        )}
      </Fragment>
    )
  }
}

CreateProjectForm.propTypes = {
  scope: PropTypes.string.isRequired,
  username: PropTypes.string,
  isModal: PropTypes.bool,
}

CreateProjectForm.defaultProps = {
  username: '',
  isModal: false,
}

export default CreateProjectForm
